// extracted by mini-css-extract-plugin
module.exports = {"root":"WebinarList_root__WI5Vs","list":"WebinarList_list__6plAS","item":"WebinarList_item__OQypt","header":"WebinarList_header__sR0UY"};